import React from 'react'

import MarkJellyfishV2ColorImage from '../assets/mark-jellyfish-v2-color.png'
// import OpenSlackImage from '../assets/open_slack@2x.png'


const SlackInstallThanks = () => (


        <div className="container align-items-center">
            <div className="row">&nbsp;</div>
            <div className="row">&nbsp;</div>
            <div className="justify-content-center row ">
                <div className="col-sm-9 col-md-6">
                    <div className="card-group">
                        {/*<div className="p-4 card">*/}
                        {/*<div className="card-body"><h1>Login</h1><p className="text-muted">Sign In to your account</p></div>*/}
                        {/*</div>*/}
                        <div className="py-3 card">

                            <div className="text-center card-body">

                                <div>
                                    <img alt="logo" className="d-md-down-none" src={MarkJellyfishV2ColorImage} height="172" width="172"/>
                                    <div>&nbsp;</div>
                                    <div><h2>Congrats<br/>Jellyfish is installed</h2></div>
                                    <div className="pb-4 pt-2">To continue... please <u>sign in</u> to your Jellyfish Dashboard.</div>
                                    {/*<div className="my-4">&nbsp;</div>*/}
                                    <div>
                                        <a href='/slack/oauth/login/link/'>
                                            <img
                                                alt="Sign in with Slack"
                                                height="40"
                                                width="172"
                                                src="https://platform.slack-edge.com/img/sign_in_with_slack.png"
                                                srcSet="https://platform.slack-edge.com/img/sign_in_with_slack.png 1x, https://platform.slack-edge.com/img/sign_in_with_slack@2x.png 2x"
                                            />
                                        </a>
                                    </div>
                                    {/*<div className="mt-4 text-muted">Need help? hello@jellyfish.chat</div>*/}
                                    {/*<div className="mt-4 text-muted">Need help?</div>*/}
                                    {/*<a href=''>Need Help?</a>*/}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

)

export default SlackInstallThanks



// WEBPACK FOOTER //
// ./src/components/SlackInstallThanks.jsx